import { render, staticRenderFns } from "./FolderMultipleOutline.vue?vue&type=template&id=770c77b2"
import script from "./FolderMultipleOutline.vue?vue&type=script&lang=js"
export * from "./FolderMultipleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports